import { useSelector } from 'react-redux';
import { AppDatePicker } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Moment from 'moment';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';

const Report28Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;
  const locale = useSelector((state) => state.global.urlData.lang);

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-6">
          <AppDatePicker
            title={ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="date.from" />
            )}
            value={values.from}
            locale={locale}
            onChange={(opt) => handleOnSetFieldValue('from', opt)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            dropdownMode="select"
            showMonthDropdown
            showYearDropdown
            showMonthYearPicker
            minDate={new Date(2020, 0, 1)}
            maxDate={Moment().toDate()}
          />
        </div>
        <div className="col-12 col-sm-6">
          <AppDatePicker
            title={ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="date.to" />
            )}
            value={values.to}
            locale={locale}
            onChange={(opt) => handleOnSetFieldValue('to', opt)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            dropdownMode="select"
            showMonthDropdown
            showYearDropdown
            showMonthYearPicker
            minDate={new Date(2020, 0, 1)}
            maxDate={Moment().toDate()}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={!values.from || !values.to}
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report28Options;
